import {Component, inject, OnInit} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";

import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {PersonalInformation} from "../../../../interfaces/personal-information";
import {TextInputComponent} from "../../../common/text-input/text-input.component";

@Component({
  selector: 'app-personal-information',
  imports: [
    FooterComponent,
    HeaderComponent,
    ReactiveFormsModule,
    FormsModule,
    TextInputComponent
  ],
  templateUrl: './personal-information.component.html',
  styleUrl: './personal-information.component.css'
})
export class PersonalInformationComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showErrorMessage: boolean = false;
  incorrectPhoneFormat: boolean = false;
  personalInformation: PersonalInformation = {
    contactableByEmail: null,
    phone: null,
    city: null,
    zip: null,
    name: null,
    email: null,
    streetAndNumber: null,
    contactableBySms: null,
    surname: null
  };
  checkboxControlContactedBySms = new FormControl();
  checkboxControlContactedByEmail = new FormControl();

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.personalInformation) {
        this.personalInformation = this.claimService.claimReport().personalInformation;
        this.checkboxControlContactedBySms = new FormControl(this.personalInformation?.contactableBySms);
        this.checkboxControlContactedByEmail = new FormControl(this.personalInformation?.contactableByEmail);
      } else {
        this.personalInformation = {
          surname: null,
          name: null,
          phone: null,
          streetAndNumber: null,
          city: null,
          zip: null,
          email: null,
          contactableByEmail: false,
          contactableBySms: false
        };
      }
    })
  }

  evaluateShowError() {
    this.showErrorMessage = !(this.personalInformation?.surname
      && this.personalInformation?.name
      && this.personalInformation?.streetAndNumber
      && this.personalInformation?.zip
      && this.personalInformation?.city
      && this.personalInformation?.phone);
    this.evaluatePhoneNumber();
  }

  evaluatePhoneNumber() {
    const phone = this.personalInformation?.phone?.trim();
    this.incorrectPhoneFormat = phone ? !phone.startsWith("+") : false;
  }

  onPhoneChange() {
    this.evaluatePhoneNumber();
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showErrorMessage && !this.incorrectPhoneFormat) {
      this.claimService.updateClaimReport({personalInformation: this.personalInformation});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['personal-information']);
      });
    }
  }

  updateContactedBySms() {
    if (this.personalInformation) {
      this.personalInformation.contactableBySms = this.checkboxControlContactedBySms.value
    }
  }

  updateContactedByEmail() {
    if (this.personalInformation) {
      this.personalInformation.contactableByEmail = this.checkboxControlContactedByEmail.value
    }
  }
}
